import { createContext, Dispatch, SetStateAction } from "react";
import { MRT_PaginationState, MRT_SortingState } from "material-react-table";

export type MediaItem = {
    id: string;
    name?: string;
    mimeType?: string;
    size?: number;
    url?: string;
    createdAt: string;
    updatedAt?: string;
    title?: string;
    canView?: boolean;
    canDelete?: boolean;
};

export type MediaActionHandlers = {
    handlePreview: (item: MediaItem) => void;
    handleDelete: (id: string) => void;
    handleDownload: (item: MediaItem) => void;
    handleCopyUrl: (url: string) => void;
    handleDeleteConfirm: () => void;
    handleDeleteCancel: () => void;
    handleUpload: (files: File[], names: string[]) => void;
    confirmDeleteSelected: () => void;
    handleToggleSelect: (id: string) => void;
    handleSelectAll: () => void;
    handleSetSelectedItems: (ids: string[]) => void;
};

export type MediaLibraryContextValues = {
    onSelectItem?: (item: MediaItem) => void;

    media: MediaItem[] | undefined;
    totalItems: number;
    isLoading: boolean;
    isError: boolean;
    isForbidden: boolean;
    refetch: () => void;

    search: string;
    setSearch: (search: string) => void;
    columnFilters: { id: string; value: any }[];
    setColumnFilters: Dispatch<SetStateAction<{ id: string; value: any }[]>>;

    sorting: MRT_SortingState;
    setSorting: Dispatch<SetStateAction<MRT_SortingState>>;

    pagination: MRT_PaginationState;
    setPagination: Dispatch<SetStateAction<MRT_PaginationState>>;

    view: "list" | "grid";
    setView: (view: "list" | "grid") => void;

    selectedItems: string[];
    mediaActions: MediaActionHandlers;

    isUploadDialogOpen: boolean;
    setIsUploadDialogOpen: (isOpen: boolean) => void;
    deleteConfirmDialogOpen: boolean;
    isDeleting: boolean;
    isUploading: boolean;
    mediaToDelete: string[];

    allowedMimeTypes?: string[];
};

export const MediaLibraryContext = createContext<MediaLibraryContextValues | null>(null);
